export const GET_SCRIBEREQUESTS = "GET_SCRIBEREQUESTS";
export const FILTER_SCRIBEREQUESTS = "FILTER_SCRIBEREQUESTS";
export const ADD_SCRIBEREQUEST = "ADD_SCRIBEREQUEST";
export const EDIT_SCRIBEREQUEST = "EDIT_SCRIBEREQUEST";
export const GET_SCRIBEREQUEST = "GET_SCRIBEREQUEST";
export const RESET_SCRIBEREQUEST = "RESET_SCRIBEREQUEST";
export const SCRIBEREQUESTS_ERROR = "SCRIBEREQUESTS_ERROR";
